module.exports = __webpack_public_path__ + "static/media/1.e47593e3.jpg";